<script setup lang="ts">
import LaunchPad from "./LaunchPad.vue";

const launchItems = [
  { text: "Templates d'interventions", icon: "mdi-wrench", route: "/intervention-templates" },
  { text: "Paramètres", icon: "mdi-cog", route: "/settings" },
  { text: "Utilisateurs", icon: "mdi-account", route: "/users" },
];
</script>

<template>
  <LaunchPad :items="launchItems" />
</template>
